//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';

// React Class -----------------------------------------------------------------
class About extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className, t } = this.props;
    const componentClasses = classNames(styles.About, {
      [className]: className,
    });
    const BUTTONS = [
      {
        textI18nKey: 'landing_About',
        url: t('url_landing_About'),
      },
      {
        textI18nKey: 'landing_titleVet',
        url: t('url_landing_titleVet'),
      },
      {
        textI18nKey: 'landing_titlePet',
        url: t('url_landing_titlePet'),
      },
      {
        textI18nKey: 'landing_titleRetail',
        url: t('url_hills_retail_order'),
      },
      {
        textI18nKey: 'landing_titleVIP',
        url: t('url_landing_titleVIP'),
      },
    ];
    const availableUrls = BUTTONS.filter((buttonsURL) => buttonsURL.url != '');

    return (
      <div className={componentClasses}>
        <h1 className={styles.Title}>{t('landing_Nutrition')}</h1>

        {availableUrls.map((button, key) => (
          <div key={key}>
            <a
              href={button.url}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.ALink}
            >
              {t(button.textI18nKey)}
            </a>
          </div>
        ))}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(About);
